import React, { useEffect, useState } from "react";
import { Box, Modal, TextField, Typography } from "@mui/material";
import Navbar from "../../Components/Navbar";
import CustomButton from "../../Components/Button";
import axios from "axios";
import { updateVat } from "../../Redux/LoginReduces";
import { useDispatch, useSelector } from "react-redux";
import { Base_Uri, Image_Uri } from "../../Constant/BaseUri";
import { RingLoader } from "react-spinners";
import { Colors } from "../../Constant/Color";
import moment from "moment/moment";
import BasicSelect from "../../Components/Dropdown";
import { Table, Tag,Typography as AntdTypography, message } from "antd";
const { Text } = AntdTypography;
function AllCompanys() {
  const dispatch = useDispatch();

  // const Information = useSelector((state) => state.loginReducer.vat);

  const [companyInformation, setCompanyInformation] = useState([]);



  const [loading, setLoading] = useState(false);


  const getVat = async () => {
    let data = sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .get(`${Base_Uri}getallvat`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let { data } = res;

        if (data.status) {
setCompanyInformation(data.data)
        //   dispatch(updateVat(data.data));
        }
      })
      .catch((error) => {});
  };
  const columns = [
    {
        title: "Logo",
        dataIndex: "companyLogo",
        key: "companyLogo",
        render: logo => (
          <img src={`${Image_Uri}/companyImage/${logo}`} alt="logo" style={{ width: 40, height: 40, objectFit: "contain" }} />
        )
      },
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "Company Number",
      dataIndex: "companyNumber",
      key: "companyNumber",
    },
    {
      title: "VAT Number",
      dataIndex: "vatNumber",
      key: "vatNumber",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Post Code",
      dataIndex: "postCode",
      key: "postCode",
    },
    {
      title: "Mobile",
      dataIndex: "mobileNumber",
      key: "mobileNumber",
    },
    {
      title: "Email",
      dataIndex: "companyEmail",
      key: "companyEmail",
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
      render: currency => <Tag color={currency === "RS" ? "blue" : "green"}>{currency}</Tag>
    },
    {
      title: "VAT Rate",
      dataIndex: "vatRate",
      key: "vatRate",
      render: rate => `${rate}%`
    },
    {
      title: "Working Hours",
      key: "workingHours",
      render: (_, record) => `${record.startTime} - ${record.endTime}`
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: status => {
        let color = status === "open" ? "green" : status === "block" ? "red" : "orange";
        return <Tag color={color}>{status.toUpperCase()}</Tag>;
      }
    },
    
  ];
  useEffect(() => {
    getVat();
  }, []);
  const [isModalOpen,setIsModalOpen] = useState(false)

  const open = ()=>{
    setIsModalOpen(true)
  }
  const onClose = ()=>{
    setIsModalOpen(false)
  }
  const [Information,setInformation] = useState({})
 const [companyInformationAdd, setCompanyInformationAdd] = useState({
    companyName: Information?.companyName,
    // companyLogo: Information?.companyLogo,
    city: Information?.city,
    postCode: Information?.postCode,
    companyAddress: Information?.companyAddress,
    companyEmail: Information?.companyEmail,
    mobileNumber: Information?.mobileNumber,
    companyNumber: Information?.companyNumber,
    vatNumber: Information?.vatNumber,
    vatRate: Information?.vatRate,
    startTime: Information?.startTime,
    endTime: Information?.posEndTime,
    currency:Information?.currency,
    // _id: Information?._id,
  });
 function objectToFormData(obj) {
    const formData = new FormData();

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        formData.append(key, obj[key]);
      }
    }

    return formData;
  }
   const [selectedFile, setSelectedFile] = useState("");
 const [imagePreview, setImagePreview] = useState("");
  const handleImageChange = (event) => {
    const file = event.target.files[0];

    setSelectedFile(file);
    const reader = new FileReader();
    reader.onload = (e) => {
      setImagePreview(e.target.result);
    };
    reader.readAsDataURL(file);
  };
  const handleSaveCompanyInformation = async () => {
    console.log(companyInformationAdd,"l")
    let flag = Object.values(companyInformationAdd).some((e, i) => !e);

    if (flag) {
      message.info("Required fields are missing");
      return;
    }

    setLoading(true);

    const formData = await objectToFormData(companyInformationAdd);
    formData.append("companyImage", selectedFile);
    console.log(companyInformationAdd,"l")
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    if (token) {
      axios
        .post(`${Base_Uri}createvat`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          let data = res.data;

          if (!data?.status) {
            setLoading(false);
            message.info(data?.message);
            return;
          }

          message.info(data.message);
          setLoading(false);
          // dispatch(updateVat(data.data));
        })
        .catch((error) => {
          message.info(error?.message);
          setLoading(false);
          return;
        });
    }
  };
  return loading ? (
    <Box
      style={{
        width: "100vw",
        height: "80vh",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      <RingLoader loading={loading} size={100} color={Colors.black} />
    </Box>
  ) : (
    <Box>
      <Navbar currentPage="All Companys" />
<Box
        style={{
          padding: 20,
          width: "100%",
        //   border: "2px solid",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          marginTop:20
        }}
      >
        <Box style={{margin:"10px 0",width:300}}>
        <CustomButton text="Create Company" style={{width:300}} onClick={open}/>
        </Box>

      <Table
      columns={columns}
      dataSource={companyInformation||[]}
      rowKey="_id"
      scroll={{ x: 1000 }}
      bordered
      style={{width:"100%"}}
    />
      </Box>
      <Modal open={isModalOpen} onClose={onClose}>
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        maxHeight: "90vh",
        overflowY: "auto",
        borderRadius: 2,
        width: 500,
      }}
    >
      <Box
              style={{
                padding: 20,
                width: "100%",
                border: "2px solid",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <div>
                <label htmlFor="avatar">
                  <img
                    src={
                      imagePreview
                        ? imagePreview
                        : `${Image_Uri}companyImage/${companyInformationAdd?.companyLogo}`
                    }
                    className="avatar-image"
                    style={{ width: 150, height: 150, borderRadius: 10 }}
                  />
                </label>
                <input
                  type="file"
                  id="avatar"
                  accept="image/*"
                  style={{
                    display: "none",
                    border: "2px solid red",
                    padding: 10,
                  }}
                  onChange={handleImageChange}
                />
              </div>
      
              <Box>
                <Typography
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 18,
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  Company Name:
                </Typography>
      
                <TextField
                  variant="standard" // <== changed this
                  margin="normal"
                  required
                  value={companyInformationAdd?.companyName}
                  onChange={(e) =>
                    setCompanyInformationAdd({
                      ...companyInformationAdd,
                      companyName: e?.target?.value,
                    })
                  }
                  InputProps={{
                    disableUnderline: true,
                    fontSize: "12px",
                  }}
                  placeholder="Enter Company Name"
                  sx={{
                    width: "400px",
                    fontSize: "12px",
                    padding: 1,
                    borderRadius: 2,
                    border: "1px solid black",
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    margin: 0,
                  }}
                />
              </Box>
      
              <Box style={{ marginTop: 10 }}>
                <Typography
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 18,
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  Mobile Number:
                </Typography>
      
                <TextField
                  variant="standard" // <== changed this
                  margin="normal"
                  required
                  value={companyInformationAdd?.mobileNumber}
                  onChange={(e) =>
                    setCompanyInformationAdd({
                      ...companyInformationAdd,
                      mobileNumber: e?.target?.value,
                    })
                  }
                  InputProps={{
                    disableUnderline: true,
                    fontSize: "12px",
                  }}
                  placeholder="Enter Mobile Number"
                  sx={{
                    width: "400px",
                    fontSize: "12px",
                    padding: 1,
                    borderRadius: 2,
                    border: "1px solid black",
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    margin: 0,
                  }}
                />
              </Box>
      
              <Box style={{ marginTop: 10 }}>
                <Typography
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 18,
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  Company Address:
                </Typography>
      
                <TextField
                  variant="standard" // <== changed this
                  margin="normal"
                  required
                  value={companyInformationAdd?.companyAddress}
                  onChange={(e) =>
                    setCompanyInformationAdd({
                      ...companyInformationAdd,
                      companyAddress: e?.target?.value,
                    })
                  }
                  InputProps={{
                    disableUnderline: true,
                    fontSize: "12px",
                  }}
                  placeholder="Enter Company Address"
                  sx={{
                    width: "400px",
                    fontSize: "12px",
                    padding: 1,
                    borderRadius: 2,
                    border: "1px solid black",
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    margin: 0,
                  }}
                />
              </Box>
              <Box style={{ marginTop: 10 }}>
                <Typography
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 18,
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  City`:
                </Typography>
      
                <TextField
                  variant="standard" // <== changed this
                  margin="normal"
                  required
                  value={companyInformationAdd?.city}
                  onChange={(e) =>
                    setCompanyInformationAdd({
                      ...companyInformationAdd,
                      city: e?.target?.value,
                    })
                  }
                  InputProps={{
                    disableUnderline: true,
                    fontSize: "12px",
                  }}
                  placeholder="Enter Company City"
                  sx={{
                    width: "400px",
                    fontSize: "12px",
                    padding: 1,
                    borderRadius: 2,
                    border: "1px solid black",
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    margin: 0,
                  }}
                />
              </Box>
              <Box style={{ marginTop: 10 }}>
                <Typography
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 18,
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                   Currency:
                </Typography>
      
                <BasicSelect
                  variant="standard" // <== changed this
                  margin="normal"
                  required
                  width="400px"
                  value={companyInformationAdd?.currency}
                  onChange={(e) =>
                    setCompanyInformationAdd({
                      ...companyInformationAdd,
                      currency:e
                    })
                  }
                  id={{rs:"RS",dollor:"$"}}
                  InputProps={{
                    disableUnderline: true,
                    fontSize: "12px",
                  }}
                  
                  placeholder="Select Currency"
                  style={{width:"400px"}}
                  sx={{
                    width: "400px",
                    fontSize: "12px",
                    padding: 1,
                    borderRadius: 2,
                    border: "1px solid black",
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    margin: 0,
                  }}
                />
              </Box>
              <Box style={{ marginTop: 10 }}>
                <Typography
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 18,
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  Postal Code
                </Typography>
      
                <TextField
                  variant="standard" // <== changed this
                  margin="normal"
                  required
                  value={companyInformationAdd?.postCode}
                  onChange={(e) =>
                    setCompanyInformationAdd({
                      ...companyInformationAdd,
                      postCode: e?.target?.value,
                    })
                  }
                  InputProps={{
                    disableUnderline: true,
                    fontSize: "12px",
                  }}
                  placeholder="Enter Postal Code"
                  sx={{
                    width: "400px",
                    fontSize: "12px",
                    padding: 1,
                    borderRadius: 2,
                    border: "1px solid black",
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    margin: 0,
                  }}
                />
              </Box>
      
              <Box style={{ marginTop: 10 }}>
                <Typography
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 18,
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  Company Email:
                </Typography>
      
                <TextField
                  variant="standard" // <== changed this
                  margin="normal"
                  required
                  value={companyInformationAdd?.companyEmail}
                  onChange={(e) =>
                    setCompanyInformationAdd({
                      ...companyInformationAdd,
                      companyEmail: e?.target?.value,
                    })
                  }
                  InputProps={{
                    disableUnderline: true,
                    fontSize: "12px",
                  }}
                  placeholder="Enter Company Email"
                  sx={{
                    width: "400px",
                    fontSize: "12px",
                    padding: 1,
                    borderRadius: 2,
                    border: "1px solid black",
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    margin: 0,
                  }}
                />
              </Box>
      
              <Box style={{ marginTop: 10 }}>
                <Typography
                  style={{
                    fontFamily: "Poppins",
                    fontSize: 18,
                    fontWeight: "600",
                    textAlign: "left",
                  }}
                >
                  Company Number:
                </Typography>
      
                <TextField
                  variant="standard" // <== changed this
                  margin="normal"
                  required
                  value={companyInformationAdd?.companyNumber}
                  onChange={(e) =>
                    setCompanyInformationAdd({
                      ...companyInformationAdd,
                      companyNumber: e?.target?.value,
                    })
                  }
                  InputProps={{
                    disableUnderline: true,
                    fontSize: "12px",
                  }}
                  placeholder="Enter Company Number"
                  sx={{
                    width: "400px",
                    fontSize: "12px",
                    padding: 1,
                    borderRadius: 2,
                    border: "1px solid black",
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    margin: 0,
                  }}
                />
              </Box>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "400px",
                }}
              >
                <Box style={{ marginTop: 10 }}>
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 18,
                      fontWeight: "600",
                      textAlign: "left",
                    }}
                  >
                    Vat Number:
                  </Typography>
      
                  <TextField
                    variant="standard" // <== changed this
                    margin="normal"
                    required
                    value={companyInformationAdd?.vatNumber}
                    onChange={(e) =>
                      setCompanyInformationAdd({
                        ...companyInformationAdd,
                        vatNumber: e?.target?.value,
                      })
                    }
                    InputProps={{
                      disableUnderline: true,
                      fontSize: "12px",
                    }}
                    placeholder="Enter Vat Number"
                    sx={{
                      width: "190px",
                      fontSize: "12px",
                      padding: 1,
                      borderRadius: 2,
                      border: "1px solid black",
                      fontFamily: "Poppins",
                      fontWeight: "bold",
                      margin: 0,
                    }}
                  />
                </Box>
      
                <Box style={{ marginTop: 10 }}>
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 18,
                      fontWeight: "600",
                      textAlign: "left",
                    }}
                  >
                    Vat Rate %:
                  </Typography>
      
                  <TextField
                    variant="standard" // <== changed this
                    margin="normal"
                    required
                    value={companyInformationAdd?.vatRate}
                    onChange={(e) =>
                      setCompanyInformationAdd({
                        ...companyInformationAdd,
                        vatRate: e?.target?.value,
                      })
                    }
                    InputProps={{
                      disableUnderline: true,
                      fontSize: "12px",
                    }}
                    type="number"
                    placeholder="Enter Vat Rate %"
                    sx={{
                      width: "190px",
                      fontSize: "12px",
                      padding: 1,
                      borderRadius: 2,
                      border: "1px solid black",
                      fontFamily: "Poppins",
                      fontWeight: "bold",
                      margin: 0,
                    }}
                  />
                </Box>
              </Box>
      
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "400px",
                }}
              >
                <Box style={{ marginTop: 10 }}>
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 18,
                      fontWeight: "600",
                      textAlign: "left",
                    }}
                  >
                    POS Start Time:
                  </Typography>
      
                  <input
                    type={"time"}
                    value={
                      companyInformationAdd?.startTime
                        ? companyInformationAdd.startTime
                        : ""
                    }
                    onChange={(e) =>
                      setCompanyInformationAdd({
                        ...companyInformationAdd,
                        startTime: e?.target?.value,
                      })
                    }
                    placeholder="Start Time"
                    style={{
                      width: "190px",
                      fontSize: "14px",
                      padding: 12,
                      borderRadius: 10,
                      border: "1px solid black",
                      fontFamily: "Poppins",
                      fontWeight: "bold",
                      margin: 0,
                    }}
                  />
                </Box>
      
                <Box style={{ marginTop: 10 }}>
                  <Typography
                    style={{
                      fontFamily: "Poppins",
                      fontSize: 18,
                      fontWeight: "600",
                      textAlign: "left",
                    }}
                  >
                    POS End Time:
                  </Typography>
      
                  <input
                    type={"time"}
                    value={companyInformationAdd?.endTime}
                    onChange={(e) =>
                      setCompanyInformationAdd({
                        ...companyInformationAdd,
                        endTime: e?.target?.value,
                      })
                    }
                    placeholder="End Time"
                    style={{
                      width: "190px",
                      fontSize: "14px",
                      padding: 12,
                      borderRadius: 10,
                      border: "1px solid black",
                      fontFamily: "Poppins",
                      fontWeight: "bold",
                      margin: 0,
                    }}
                  />
                </Box>
              </Box>
      
              <CustomButton
                onClick={handleSaveCompanyInformation}
                text="Save Company Information"
                style={{
                  width: 400,
                  marginTop: 5,
                  borderRadius: 2,
                  fontSize: "14px",
                }}
              />
            </Box>
    </Box>
    </Modal>
    </Box>
   
  );
}

export default AllCompanys;
